/**
 * @desc 计算库容
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/calculatePositionStorageCapacity`, {
      method: "GET",

      ...options,
    }),
  );
}
